export default "__VITE_ASSET__BNMlMOoY__"